import React from 'react';
import { ReportsTitleAccent, ReportsTitleWrapper } from './ReportsTitle.styled';

interface Props {
  title: string;
  accent: string;
}

const ReportsTitle = ({ title, accent }: Props) => {
  return (
    <ReportsTitleWrapper>
      {title} <ReportsTitleAccent>{accent}</ReportsTitleAccent>
    </ReportsTitleWrapper>
  );
};

export default ReportsTitle;
